module.exports = __webpack_public_path__ + "static/textYes-2d4ea0c2dc0631e58da9f1a9f447ec7b.png";